export default __webpack_public_path__ + "media/images/series-a-news/brazil-journal-logo-12a979b15e68d223dc8c3ae3a7e82390.png";